var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ad-slot-page" },
    [
      _c("div", { staticClass: "hero" }, [
        _c("div", [
          _c("span", [_vm._v("AD SLOT")]),
          _c("h2", [_vm._v("投流位")]),
          _c("p", [
            _vm._v(
              "已启用 " +
                _vm._s(_vm.guide.enabledSlots || 0) +
                "/" +
                _vm._s(_vm.guide.totalSlots || 0) +
                " 个投放位。"
            ),
          ]),
        ]),
      ]),
      _c(
        "el-card",
        {
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.guide.items || [], size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "sort", label: "序号", width: "70" },
              }),
              _c("el-table-column", {
                attrs: { prop: "pageName", label: "页面", width: "110" },
              }),
              _c("el-table-column", {
                attrs: { prop: "title", label: "投流位", "min-width": "160" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "description",
                  label: "说明",
                  "min-width": "220",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.status === "pending" || row.status === "off"
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.runAction(row.id, "enable")
                                  },
                                },
                              },
                              [_vm._v("启用")]
                            )
                          : _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.runAction(row.id, "disable")
                                  },
                                },
                              },
                              [_vm._v("停用")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }